import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})

export class AlertComponent implements OnInit {

  @Input() message: string;
  @Input() okBtn: string;

  public onClose: Subject<boolean>;

  constructor(
    public bsModalRef: BsModalRef,
  ) {}

  ngOnInit() {
    this.onClose = new Subject();
  }

  public onConfirm(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

}
